import { CaseType } from "@/Case/services/CaseType";

export const CaseAccessConditions = {
  [CaseType.ift]: true,
  [CaseType.mih]: true
};
